import { DateService } from '@shared/services/date';
import { Flex } from 'antd';
import { memo } from 'react';
import { Text } from '@shared/ui/antd';
import styles from './date-separator.module.scss';

interface DateSeparatorProps {
  date: string;
}

/**
 * @description memoized component
 */
export const DateSeparator = memo<DateSeparatorProps>(({ date }) => {
  return (
    <Flex className={styles.root} align="center" justify="center">
      <Text className={styles.text} variant="xs" fontWeight={500}>
        {DateService.calendarDay(date)}
      </Text>
    </Flex>
  );
});
